import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { StyledHolder } from '../../Avatar/styled';
import { StyledListCell } from '../ListCell/styled';
import { StyledTagsItem } from '../../Tags/TagsItem/styled';

export const StyledListItem = styled.div`
  display: table-row;
  color: ${(p) => p.isHead && p.theme.alias.subtle};
  box-shadow: ${(p) => p.theme.shadows.bottom};
`;

export const StyledListLink = styled(StyledListItem).attrs({
  as: Link,
})`
  display: table-row;

  &:hover {
    background-color: ${(p) => p.theme.alias.shadow};

    ${StyledTagsItem} {
      box-shadow: none;
      background-color: ${(p) => p.theme.alias.bg};
    }

    ${StyledHolder} {
      background-color: ${(p) => p.theme.alias.bg};
    }
  }

  &:focus-visible {
    box-shadow: ${(p) => p.theme.shadows.focusInner};
  }

  ${StyledListCell} {
    padding: ${(p) => p.$hasTag && `${p.theme.space[1]} ${p.theme.space[3]}`};
  }
`;
